import { useI18n } from '../../i18n'

export default function ModelDetailConnectionHistory({ events, loading }) {
  const { t } = useI18n()
  return (
    <section
      className="model-detail-connection-history"
      aria-label={t('modelDetail.connectionHistory.title')}
    >
      <h2 className="model-detail-media-section-title">
        {t('modelDetail.connectionHistory.title')}
      </h2>
      {loading ? (
        <p className="model-detail-loading">{t('common.loading')}</p>
      ) : events.length ? (
        <ul className="model-detail-connection-events">
          {events.map((e) => (
            <li key={e.id} className="model-detail-connection-event">
              <span className="model-detail-connection-event-type">{e.event_type}</span>
              <span className="model-detail-connection-event-date">
                {e.created_at ? new Date(e.created_at).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' }) : t('common.notAvailable')}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="model-detail-empty">{t('modelDetail.connectionHistory.empty')}</p>
      )}
    </section>
  )
}
